import type { ReportsAction, ReportState } from './types';
import { ReportsActions } from './types';

/**
 * Reducer for the reports domain
 *
 * @param state - The current state of the reports domain
 * @param action - The action to perform on the state
 * @returns The new state of the reports domain
 *
 * @example
 * const state: ReportState = {
 *   currentReport: null,
 *   appliedFilters: {
 *     startDate: new Date(),
 *     endDate: new Date(),
 *     preset: DateRangePresets.TODAY,
 *     startHour: '',
 *     endHour: '',
 *     filters: {},
 *   },
 *   isInitialized: false,
 * };
 */
export const reportsReducer = (state: ReportState, action: ReportsAction): ReportState => {
  switch (action.type) {
    case ReportsActions.SELECT_REPORT:
      return { ...state, currentReport: action.payload.report };

    case ReportsActions.UPDATE_FILTERS:
      return { ...state, appliedFilters: action.payload.filters };

    case ReportsActions.RESET_FILTERS:
      return { ...state, appliedFilters: { ...state.appliedFilters, filters: {} } };

    case ReportsActions.SET_INITIALIZED:
      return { ...state, isInitialized: true };

    default:
      return state;
  }
};
